const ID_TOKEN_KEY = "id_token"
const ID_TOKEN_REFRESH_KEY = "id_refresh_token"

export default {
  getToken() {
    return window.localStorage.getItem(ID_TOKEN_KEY)
  },

  getRefreshToken() {
    return window.localStorage.getItem(ID_TOKEN_REFRESH_KEY)
  },

  saveToken(token, refreshToken) {
    window.localStorage.setItem(ID_TOKEN_KEY, token)
    window.localStorage.setItem(ID_TOKEN_REFRESH_KEY, refreshToken)
  },

  destroyToken() {
    window.localStorage.removeItem(ID_TOKEN_KEY)
    window.localStorage.removeItem(ID_TOKEN_REFRESH_KEY)
  },

  parseJwt() {
    let token = this.getToken()
    var base64Url = token.split(".")[1]
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/")
    var jsonPayload = decodeURIComponent(
      Buffer.from(base64, "base64")
        .toString("ascii")
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join("")
    )

    return JSON.parse(jsonPayload)
  },
}
